/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Upload_DescInputs */

const en_register_onboarding_personal_info_upload_desc = /** @type {(inputs: Register_Onboarding_Personal_Info_Upload_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It will be read by AI so that you don't have to fill out your profile manually.`)
};

const de_register_onboarding_personal_info_upload_desc = /** @type {(inputs: Register_Onboarding_Personal_Info_Upload_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er wird von einer KI ausgelesen, damit du dein Profil nicht manuell ausfüllen musst.`)
};

/**
* | output |
* | --- |
* | "It will be read by AI so that you don't have to fill out your profile manually." |
*
* @param {Register_Onboarding_Personal_Info_Upload_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_upload_desc = /** @type {((inputs?: Register_Onboarding_Personal_Info_Upload_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Upload_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_upload_desc(inputs)
	return en_register_onboarding_personal_info_upload_desc(inputs)
});